import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScorecastDataService {
    scorecastData: any[] = [];
    setScorecastData(value: any) {
        if (value) {
            this.scorecastData.push(value);
        } else {
            this.scorecastData = [];
        }
    }
    getScorecastData(): any {
        return this.scorecastData;
    }
}
